import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { apiUrl } from '@app/app.constants';
import { PasswordStrength } from '@app/core/interfaces/password-strength';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class PasswordStrengthRepository {
  constructor(private http: HttpClient) {}

  checkStrength(password: string): Observable<PasswordStrength> {
    return this.http.post<PasswordStrength>(apiUrl('/passwordStrength'), {
      password,
    });
  }

  getStrongPassword(): Observable<string> {
    return this.http.get(apiUrl('/strongPassword'), {
      responseType: 'text',
    });
  }
}
